import { render, staticRenderFns } from "./LivestreamEnded.vue?vue&type=template&id=0795ca1e&"
import script from "./LivestreamEnded.vue?vue&type=script&lang=js&"
export * from "./LivestreamEnded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports